import { Component } from '@theme/component';
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

export class RecentProductsComponent extends Component {
  async connectedCallback() {
    super.connectedCallback();

    const currentProductId = this.dataset.currentProductId;
    let viewedProducts = RecentlyViewed.getProducts();

    // Filter out the current product ID so we don't display it in the list
    if (currentProductId) {
      viewedProducts = viewedProducts.filter((id) => id !== currentProductId);
    }

    if (viewedProducts.length === 0) {
      // Keep it hidden if no recently viewed products exist
      this.style.setProperty('display', 'none', 'important');
      return;
    }

    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    // Build the query: q=id:ID1 OR id:ID2...
    const query = viewedProducts.map((id) => `id:${id}`).join(' OR ');
    const url = new URL('/search', window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product');

    try {
      const html = await sectionRenderer.getSectionHTML(sectionId, false, url);
      if (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('.recent-products-grid');
        const currentGrid = this.querySelector('.recent-products-grid');

        if (newGrid && currentGrid && newGrid.children.length > 0) {
          currentGrid.innerHTML = newGrid.innerHTML;
          this.style.setProperty('display', 'block', 'important');
        } else {
          this.style.setProperty('display', 'none', 'important');
        }
      }
    } catch (e) {
      console.error('Failed to load recently viewed products:', e);
      this.style.setProperty('display', 'none', 'important');
    }
  }
}

if (!customElements.get('recent-products-component')) {
  customElements.define('recent-products-component', RecentProductsComponent);
}
